import { createSlice } from '@reduxjs/toolkit';
import { ORDER } from '../types';

const ordersSlice = createSlice({
    name: ORDER,
    reducers: {
        getCompletedOrdersRequest() { },
        getCompletedOrdersSuccess(state, action) {
            const { data, count } = action.payload;
            state.completedOrders = data;
            state.completedCount = count;
        },
        setSelectedOrder(state, action) {
            const defaultData = state.selectedOrder;
            state.selectedOrder = { ...defaultData, ...action.payload };
        },
        updateOrderStatusRequest() { },
        setOrderSorting(state, action) {
            state.sorting = action.payload;
        },
        setOrderFiltering(state, action) {
            state.filtering = action.payload;
        },
        setOrderPagination(state, action) {
            state.pagination = action.payload;
        },
        resetOrderFilters(state) {
            state.sorting = [];
            state.filtering = {};
            state.pagination = {
                pageIndex: 0,
                pageSize: 10
            };
        }
    },
    initialState: {
        activeOrder: {},
        completedOrders: [],
        selectedOrder: {
            show: false,
            title: 'Order Details',
            closeText: 'Close',
            data: {}
        },
        completedCount: 0,
        sorting: [],
        filtering: {},
        pagination: {
            pageIndex: 0,
            pageSize: 10
        }
    }
});
export const {
    getCompletedOrdersRequest,
    getCompletedOrdersSuccess,
    setSelectedOrder,
    updateOrderStatusRequest,
    setOrderSorting,
    setOrderFiltering,
    setOrderPagination,
    resetOrderFilters
} = ordersSlice.actions;

export const ordersReducer = ordersSlice.reducer;
